import { render, staticRenderFns } from "./SessionNotice.vue?vue&type=template&id=11eac524"
import script from "./SessionNotice.vue?vue&type=script&lang=js"
export * from "./SessionNotice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports